import React, {useContext, useEffect, useRef} from "react";
import {CBContext} from "./CBContext";
import {FormModal, getPatchValues} from "../utils/utils";
import {Box, Button, CircularProgress} from "@mui/material";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import API from "../utils/API";
import {ProgressContext} from "../utils/ProgressContext";
import {Form, Formik} from "formik";
import {cancelSchema} from "./validations";
import TextField from "../utils/components/TextField";
import {generalAPI, removeNulls} from "./utils";


async function cancelAPI(transactionID, data){
    const response = await API.post(`cbs/${transactionID}/canceled/`, data);
    return response.data;
}

export default function CancellationForm(){
    const {cbState, cbDispatch} = useContext(CBContext);
    const {modalType, transactionId, status} = cbState.baseData;
    const {handleProgressOpen, handleProgressClose} = useContext(ProgressContext);
    const formikRef = useRef();
    const queryClient = useQueryClient();

    const {data: cbData, isFetching: cbIsFetching} = useQuery(
        ['cbs', cbState.baseData.transactionId],
        () => generalAPI(`cbs/${cbState.baseData.transactionId}/`),
        {
            refetchOnWindowFocus: false,
            retry: false,
            enabled: cbState.baseData.status >= 1,
            select: data => {
                data = removeNulls(data);
                return data;
            }
        }
    );

    useEffect(() => {
        if (!cbState.baseData.pages[cbState.baseData.activeStep].visited && cbData && cbState.baseData.status !== 0 && !cbState.baseData.cloning) {
            cbDispatch({
                type: 'addUpdateFormData',
                data: {'cancel': cbData}
            })
        }
    }, [cbData, cbState.baseData.status, cbState.baseData.activeStep, cbState.baseData.pages, cbState.baseData.cloning, cbDispatch]);


    const mutation = useMutation(
        ['cbs', transactionId, 'canceled'],
        data => cancelAPI(transactionId, data),
        {
            onMutate: () => handleProgressOpen(),
            onSettled: () => handleProgressClose(),
            onSuccess: () => {
                cbDispatch({
                    type: 'addBaseData',
                    data: {modalType: '', status: 7, navigateOnSuccess: -2}
                });
                queryClient.invalidateQueries(['cbs', cbState.baseData.transactionId])
            }
        }
    )

    const footer = <>
        <Button variant={'outlined'} onClick={() => cbDispatch({
            type: 'addBaseData',
            data: {modalType: ''}
        })}>Close</Button>
        <Button sx={{ml: 3}} disabled={status < 1} onClick={() => formikRef.current.submitForm()} variant={'contained'}>Save</Button>
    </>

    return (
        <>
            <FormModal
                open={modalType === 'cancel'}
                title={'Cancel'}
                maxWidth={'xl'}
                width={'500px'}
                footer={footer}
            >
                <Formik
                    innerRef={formikRef}
                    initialValues={cbState.formData.cancel}
                    validationSchema={cancelSchema}
                    enableReinitialize={true}
                    validateOnChange={false}
                    onSubmit={values => {
                        values['status'] = 7
                        let finalValues = getPatchValues(cbState.updateData.cancel, values)
                        mutation.mutate(finalValues)
                    }}
                >
                    <Form>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '16px',
                                left: '150px'
                            }}
                        >
                            {cbIsFetching && <CircularProgress size={'2rem'}/>}
                        </Box>
                        <TextField
                            name={'canceled_by'}
                            label={'Cancel'}
                            required
                            fullWidth
                            disabled={status < 1 || status === 7}
                            select
                            options={{
                                "-1": "SELECT",
                                "0": 'BGSS',
                                "1": "CLIENT"
                            }}
                        />
                    </Form>
                </Formik>
            </FormModal>
        </>
    )
}